import React from 'react';

import IsometricIcon from '../../../IsometricIcon';
import ED from './ED';
import GO from './GO';
import OP from './OP';
import TR from './TR';

const PriorityBoarding = ({ ...props }) => {
  return <IsometricIcon icons={{ ED, GO, OP, TR }} {...props} />;
};

export default PriorityBoarding;
